import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

const STATUSES = ["pending", "active", "paused"];

export default function AdminRestaurants() {
  const [list, setList] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/restaurants");
      setList(data);
    } catch (e) { toast.error("Failed"); }
  };
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try {
      await api.patch(`/admin/restaurants/${id}/status`, { partner_status: status });
      toast.success("Status updated");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  const setAlcohol = async (id, value) => {
    try {
      await api.patch(`/admin/restaurants/${id}/settings`, { serves_alcohol: value });
      toast.success(value ? "Alcohol enabled" : "Alcohol disabled (drinks_alc items hidden)");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="space-y-5 animate-fade-up">
      <header>
        <p className="text-amber text-xs uppercase tracking-[0.18em] font-medium mb-2">Restaurants</p>
        <h1 className="font-serif text-4xl">Partner roster</h1>
      </header>

      <div className="tablo-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-cream">
            <tr className="text-xs uppercase tracking-wider text-light-ink">
              <th className="text-left p-3">Name</th>
              <th className="text-left p-3">Area</th>
              <th className="text-left p-3">Vibe</th>
              <th className="text-left p-3">GSTIN</th>
              <th className="text-left p-3">Rating</th>
              <th className="text-left p-3">Serves alcohol</th>
              <th className="text-left p-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {list.map((r) => (
              <tr key={r.id} className="border-t border-tablo-border hover:bg-off-white" data-testid={`admin-rest-row-${r.id}`}>
                <td className="p-3 font-medium">{r.name}</td>
                <td className="p-3">{r.area}</td>
                <td className="p-3 text-xs">{r.vibe_tags.join(", ")}</td>
                <td className="p-3 text-xs font-mono">{r.gstin}</td>
                <td className="p-3">{r.google_rating}</td>
                <td className="p-3">
                  <Switch
                    checked={!!r.serves_alcohol}
                    onCheckedChange={(v) => setAlcohol(r.id, v)}
                    data-testid={`admin-rest-alcohol-${r.id}`}
                  />
                </td>
                <td className="p-3">
                  <Select value={r.partner_status} onValueChange={(v) => setStatus(r.id, v)}>
                    <SelectTrigger className="w-32 h-8 text-xs" data-testid={`admin-rest-status-${r.id}`}><SelectValue/></SelectTrigger>
                    <SelectContent>
                      {STATUSES.map((s) => <SelectItem key={s} value={s} className="text-xs">{s}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
